import {Injectable} from "@angular/core";
import {ApiService} from "../../../core/services/api.service";
import {IProfileUI, IResponseApi} from "@core/models";

@Injectable({
  providedIn: 'any'
})
export class UserSpecificService extends ApiService {

  loadProfileUI() {
    return this.postRequest<IResponseApi<IProfileUI>>('/user/setting/loadusersetting', {}
    )
  }

}
